<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card no-margin-bottom">
          <div class="card-block">
            <ui-data-table
              id="marketplace-categories-list"
              ref="list"
              :columns="columns"
              :filters="filters"
              :endpoint="endpoint"
              :includes="includes"
              size="sm"
            >
              <template
                slot="name"
                slot-scope="row"
              >
                <a
                  href="#"
                  @click.prevent="click(row)"
                >{{ row.name }}</a>
              </template>

              <template
                slot="market_id"
                slot-scope="row"
              >
                {{ row.marketplace.title }}
              </template>

              <template
                slot="templates"
                slot-scope="row"
              >
                <template v-if="row.templates === null">
                  0
                </template>
                <template v-else>
                  {{ Object.keys(row.templates).length }}
                </template>
              </template>
            </ui-data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '../services/ApiService';
import ErrorsMixins from '../mixins/ErrorsMixins';

export default {
  name: 'AppPageMarketplacesCategories',
  mixins: [ErrorsMixins],
  data() {
    return {
      columns: [
        {
          name: 'ID',
          key: 'id',
          sorting: true,
          styles: 'text-right',
        },
        {
          name: 'Marketplace',
          key: 'market_id',
        },
        {
          name: this.$t('Name'),
          key: 'name',
          sorting: true,
        },
        {
          name: this.$t('Full Name'),
          key: 'name_full',
          sorting: true,
        },
        {
          name: 'Marketplace ID',
          key: 'marketplace_uid',
        },
        {
          name: 'Templates',
          key: 'templates',
        },
      ],
      filters: [
        {
          name: 'ID',
          key: 'id',
          type: 'integer',
        },
        {
          name: 'Marketplace',
          key: 'market_id',
          type: 'select',
          source: {
            endpoint: `${ApiService.getLink('marketplaces')}&limit=500&order_by=title,asc`,
            key: 'id',
            value: 'title',
          },
        },
        {
          name: this.$t('Name'),
          key: 'name',
          type: 'string',
        },
        {
          name: this.$t('Full Name'),
          key: 'name_full',
          type: 'string',
        },
        {
          name: 'Marketplace ID',
          key: 'marketplace_uid',
          type: 'string',
        },
      ],
      endpoint: `${ApiService.getLink('marketplaces/categories')}&includes=marketplace`,
      includes: ['marketplace'],
    };
  },
  methods: {
    click(category) {
      this.saveCurrentAndGo('marketplacesCategories', { name: 'MarketplacesCategory', params: { categoryId: category.id } });
    },
  },
};
</script>
